/* @flow */

import { makeListLink } from './utils';

export default makeListLink({ pathname: '/programs', children: 'programs' });



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/components/Links/ProgramsLink.js